<template>
  <div class="container">
    <router-view
      ref="container"
      :curriculumMaterial="curriculumMaterial"
      :tchPlanId="tchPlanId"
    ></router-view>
  </div>
</template>

<script>
export default {
  name: 'container',
  props: {
    curriculumMaterial: Object,
    tchPlanId: Number,
  },
  watch: {
    curriculumMaterial() {
      console.log('来自Container')
      console.log(this.curriculumMaterial)
      console.log(this.tchPlanId)
    },
  },
}
</script>

<style lang="scss" scoped></style>
